/* Change this file to get your Personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation";

// Splash Screen

const splashScreen = {
  enabled: true,
  animation: splashAnimation,
  duration: 2000
};

// Summary And Greeting Section

const illustration = {
  animated: true
};

const greeting = {
  username: "Angadpreet Nagpal",
  title: "Hi all, I'm Angadpreet Nagpal",
  subTitle: emoji(
    "A product-focused software engineer currently working as an SDE 3 in the Marketplace division at Flipkart, with deep experience in Search (Apache Lucene, semantic search) and Machine Learning. I hold an MS in Computer Science from the University of Southern California and am pursuing an MBA at IIM Ahmedabad."
  ),
  resumeLink: "/resume.pdf",
  displayGreeting: true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/angadp",
  linkedin: "https://www.linkedin.com/in/angadpreet-nagpal/",
  gmail: "nagangapal@gmail.com",
  medium: "https://nagangapal.medium.com/",
  display: true
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "LIFE LONG LEARNER WITH A PASSION FOR TRANSFORMATIVE TECHNOLOGIES.",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications"
    ),
    emoji(
      "⚡ Lightening fast backends formulated using best practices learnt over the years spent at various startups and organizations"
    ),
    emoji(
      "⚡ Progressive Web Applications ( PWA ) in normal and SPA Stacks"
    ),
    emoji(
      "⚡ Integration of third party services such as Firebase/ AWS / Digital Ocean"
    )
  ],

  softwareSkills: [
    {
      skillName: "java",
      fontAwesomeClassname: "fab fa-java"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "android",
      fontAwesomeClassname: "fab fa-android"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    }
  ],
  display: true
};

// Education Section

const educationInfo = {
  display: true,
  schools: [
    {
      schoolName: "Indian Institutes of Management Ahmedabad",
      logo: require("./assets/images/iimaLogo.png"),
      subHeader: "Master of Business Administration (Blended) - BPGP",
      duration: "September 2024 - May 2026",
      desc: "Blended Post Graduate Programme in Management, one of 60+ selected from a pool of 15,000+ applicants. GMAT 700.",
      descBullets: []
    },
    {
      schoolName: "University of Southern California",
      logo: require("./assets/images/uscLogo.png"),
      subHeader: "Master of Science in Computer Science",
      duration: "September 2017 - May 2019",
      desc:
        "Courses: Machine Learning, Introduction to AI, Applied NLP, Data Mining, Algorithms, Web Technologies",
      descBullets: [
        "Created projects in web technologies and big data analytics to solve real world problems"
      ]
    },
    {
      schoolName: "Thapar University",
      logo: require("./assets/images/thaparLogo.png"),
      subHeader: "Bachelor of Engineering in Computer Science",
      duration: "June 2011 - June 2015",
      desc:
        "Ranked top 10% in the program. Took courses about Software Engineering, Web Security, Operating Systems.",
      descBullets: [
        "Represented the University in national level coding competition.",
        "Created a website to help students prepare for placements with a team of 3 people."
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true,
  experience: [
    {
      Stack: "Backend",
      progressPercentage: "85%"
    },
    {
      Stack: "Frontend/Design",
      progressPercentage: "75%"
    },
    {
      Stack: "Machine Learning",
      progressPercentage: "55%"
    }
  ],
  displayCodersrank: false
};

// Work experience section

const workExperiences = {
  display: true,
  experience: [
    {
      role: "Software Development Engineer 3",
      company: "Flipkart",
      companylogo: require("./assets/images/flipkartLogo.png"),
      date: "December 2024 – Present",
      desc:
        "Working as an SDE 3 in the Marketplace division to build search and pricing systems for 10M+ daily active shoppers.",
      descBullets: [
        "Cross-collaborated with product, design, and business teams to launch Flipkart Grocery on the Shopsy app, expanding grocery accessibility to Tier-2 and Tier-3 cities.",
        "Architected high-throughput search and pricing pipelines, cutting data ingestion latency by 20% through SOLID design principles, strict API contracts, and automated retry throttles.",
        "Launched and trained production ranker models using advanced feature engineering, resulting in a 15% increase in search accuracy and an 8% lift in checkout conversion rates.",
        "Owned reliability of a tier-1 core shopping service, maintaining 99.95% uptime during peak traffic and reducing MTTR through proactive monitoring and alerting.",
        "Integrated an LLM into the production search path to generate real-time query suggestions, keeping latency overhead under 5ms across 10M+ daily active shoppers.",
        "Mentored and coached 4 mid-level engineers on system design, coding standards, and project ownership to accelerate their promotion."
      ]
    },
    {
      role: "Software Development Engineer 2",
      company: "Amazon",
      companylogo: require("./assets/images/amazonLogo.png"),
      date: "August 2021 – November 2024",
      desc:
        "Worked as an SDE-2 to develop and deploy solutions for the Product Search division, written on top of Apache Lucene",
      descBullets: [
        "Shipped semantic search using the Lucene KNN algorithm to surface relevant products across all Amazon locales, improving search relevance and click-through rates by 20% for buyers.",
        "Developed and deployed search solutions for the Product Search division, built directly on Apache Lucene.",
        "Launched Video Search as part of a US market initiative, surfacing relevant video results in a dedicated tab alongside product results.",
        "Created a query-replay-based solution for hyper-parameter optimization of Machine Learning algorithms, tuning relevance models across seven global marketplaces."
      ]
    },
    {
      role: "Senior Software Engineer",
      company: "M56 Studios",
      companylogo: require("./assets/images/m56Logo.png"),
      date: "October 2020 – August 2021",
      desc: "Designed an end-to-end solution for a smart showerhead IOT device.",
      descBullets: [
        "Led product development of a consumer React Native app (Get Hai smart showerhead), lifting user engagement by 30% through iterative product improvements.",
        "Built custom SVG visualizations and Express-backed APIs, improving frontend performance by 30% to strengthen user retention."
      ]
    },
    {
      role: "Software Engineer",
      company: "Zynga Games",
      companylogo: require("./assets/images/zyngaLogo.png"),
      date: "March 2020 – Oct 2020",
      descBullets: [
        "Coded and managed levels for Willy Wonka Slots \u2013 including More More Jelly, and One More Round Please and Arcade games. The game is rated 4.2 on Google App Store, has more than 1M installs.",
        "Conducted EOS experiments to optimize game play experience with different variants and audiences."
      ]
    },
    {
      role: "Software Engineer",
      company: "Microsoft",
      companylogo: require("./assets/images/microsoftLogo.png"),
      date: "June 2015 – June 2017",
      descBullets: [
        "Built microservices from legacy to speed up billing process for Volume Licensing, $40 billion business.",
        "Led the development of internal tools (Certificate Management, BCDR) to increase automation.",
        "Analysed sales records to model discount to be given to companies using Azure Machine Learning."
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects */

const openSource = {
  showGithubProfile: "false",
  display: false
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [],
  display: false
};

// Achievement Section

const achievementSection = {
  title: emoji("Achievements And Certifications \ud83c\udfc6 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Amazon Search Sweeper Award",
      subtitle:
        "Awarded the Search Sweeper award in March 2024 for cleaning up leftover Tensorflow code after I deprecated it from our codebase. Only 3 people were awarded this in a group of over 500.",
      image: require("./assets/images/amazonSweeper.webp"),
      imageAlt: "Amazon Search Sweeper Award",
      footerLink: []
    },
    {
      title: "CCNA",
      subtitle:
        "Completed the CCNA certification exam, proving proficiency in networking systems.",
      image: require("./assets/images/ccnaLogo.webp"),
      imageAlt: "CCNA",
      footerLink: []
    },
    {
      title: "Microsoft certified Azure developer",
      subtitle:
        "Completed Certifcation from Microsoft to build applications on Azure.",
      image: require("./assets/images/azureLogo.webp"),
      imageAlt: "Microsoft certified Azure developer",
      footerLink: []
    }
  ],
  display: true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true",
  blogs: [
    {
      url: "https://nagangapal.medium.com/my-journey-into-computer-vision-part-1-6d81eddb265c",
      title: "My Journey into Computer Vision Part-1",
      description:
        "A 6 part series explaining my journey into computer vision"
    },
    {
      url: "https://nagangapal.medium.com/my-journey-into-computer-vision-part-2-8e69489c860d",
      title: "My Journey into Computer Vision Part-2",
      description:
        "A 6 part series explaining my journey into computer vision, where I explain creating a simple neural network for MNIST"
    },
    {
      url: "https://nagangapal.medium.com/my-3-months-with-computer-vision-part-3-simple-neural-network-from-scratch-for-mnist-fa0035daac98",
      title: "My Journey into Computer Vision Part-3",
      description:
        "A 6 part series explaining my journey into computer vision, where I show the code for MNIST data"
    },
    {
      url: "https://nagangapal.medium.com/my-3-months-with-computer-vision-part-4-predicting-catsvdog-mnist-but-with-bigger-images-and-f403f35be927",
      title: "My Journey into Computer Vision Part-4",
      description:
        "A 6 part series explaining my journey into computer vision, where I try to predict in between cat and dog"
    },
    {
      url: "https://nagangapal.medium.com/my-3-months-with-computer-vision-part-5-transfer-learning-for-stanford-dog-dataset-34ed165f872e",
      title: "My Journey into Computer Vision Part-5",
      description:
        "A 6 part series explaining my journey into computer vision, where I try to distinguish between different dog breeds"
    },
    {
      url: "https://nagangapal.medium.com/my-3-moths-with-computer-vision-part-6-udacity-facial-keypoints-understanding-the-problem-21e00420be48",
      title: "My Journey into Computer Vision Part-6",
      description:
        "A 6 part series explaining my journey into computer vision, where I try to plot facial keypoints."
    }
  ],
  display: true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE \ud83d\ude05"
  ),
  talks: [],
  display: false
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast \ud83c\udf99\ufe0f"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",
  podcast: [],
  display: false
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",
  display: true
};

const contactInfo = {
  title: emoji("Contact Me \u260e\ufe0f"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+91-7009577797",
  email_address: "nagangapal@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter",
  display: false
};

const isHireable = false;

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
